<template>
  <div class="card-body" v-if="dates && dates.length">
    <div class="text-center mb-3">
      <form-button @clicked="download" :indicator="downloading"
        >Download Loss Of Use Dates</form-button
      >
    </div>

    <inputbox
      v-for="(date, index) in dates"
      name="date"
      :key="'input-' + index"
      :value="formatDate(date.value)"
      :readonly="true"
      :label="date.date.label"
    ></inputbox>
  </div>

  <div class="card-body" v-else>
    <p class="text-center">
      No dates have been recorded for this claim.
    </p>
  </div>
</template>
<script>
export default {
  props: {
    incident: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      downloading: false
    };
  },

  computed: {
    dates() {
      return this.$store.getters['Incident/dates'] || [];
    }
  },

  methods: {
    formatDate(value) {
      return window.DateManager.format(value);
    },

    download() {
      this.downloading = true;

      window.Ajax.download(`/debt-recovery/${this.incident}/dates/download`)
        .then(() => {
          this.downloading = false;
        })
        .catch(error => {
          this.downloading = false;
          window.toastify.error(
            'Error',
            'There was a problem downloading the export, please try again.'
          );
        });
    }
  }
};
</script>
